module.exports = __webpack_public_path__ + "static/media/seoul.71fd0d33.jpg";